<router-outlet></router-outlet>
<app-toast-host />
<app-pwa-install-banner />
